import React from "react";

const formatCurrency = (amount) =>
  new Intl.NumberFormat("ru-RU").format(Number(amount) || 0);

const formatMonthYear = (date) => {
  const months = [
    "Январь",
    "Февраль",
    "Март",
    "Апрель",
    "Май",
    "Июнь",
    "Июль",
    "Август",
    "Сентябрь",
    "Октябрь",
    "Ноябрь",
    "Декабрь",
  ];
  return `${months[date.getMonth()]} ${date.getFullYear()}`;
};

const SalaryMonthTotalsSummary = ({ totals, selectedMonth }) => {
  if (!totals?.totals) return null;

  const { total_salary: totalSalary, total_paid: totalPaid, total_remainder: totalRemainder } =
    totals.totals;

  return (
    <div className="salary-month-totals">
      <div className="salary-month-totals__summary">
        <div className="salary-month-totals__summary-item">
          <span className="salary-month-totals__summary-label">Период:</span>
          <span className="salary-month-totals__summary-value">
            {formatMonthYear(selectedMonth)}
          </span>
        </div>
        <div className="salary-month-totals__summary-item">
          <span className="salary-month-totals__summary-label">
            Общая сумма к выплате:
          </span>
          <span className="salary-month-totals__summary-value salary-month-totals__summary-value--amount">
            {formatCurrency(totalSalary)} тг
          </span>
        </div>
        <div className="salary-month-totals__summary-item">
          <span className="salary-month-totals__summary-label">Выплачено:</span>
          <span className="salary-month-totals__summary-value salary-month-totals__summary-value--amount">
            {formatCurrency(totalPaid)} тг
          </span>
        </div>
        <div className="salary-month-totals__summary-item">
          <span className="salary-month-totals__summary-label">Остаток:</span>
          <span className="salary-month-totals__summary-value salary-month-totals__summary-value--amount">
            {formatCurrency(totalRemainder)} тг
          </span>
        </div>
      </div>
    </div>
  );
};

export default SalaryMonthTotalsSummary;
